import { ALPHA__Drawer as DSDrawer } from "@JohnLewisPartnership/jl-design-system/dist/components/drawer/ALPHA/Drawer";
import styles from "../Badges.module.scss";

export type DrawerProps = {
  isOpen: boolean;
  handleClose: () => void;
  badgeHeader: string;
  description: string[];
};

export const Drawer = ({
  isOpen,
  handleClose,
  badgeHeader,
  description,
}: DrawerProps) => {
  return (
    <DSDrawer
      isOpen={isOpen}
      onClose={handleClose}
      header={badgeHeader}
      headerStyleModifier={styles.header}
      isHeaderFixed={true}
      isNarrow={false}
      rootId="page-root"
      isFooterFixed
      isDrawerLeft={false}
      footerChildren={
        <span className={styles.poweredBy}>
          Powered by Skin Match Technology
        </span>
      }
    >
      {description.map((para: string, i: number) => (
        <p key={i}>{para}</p>
      ))}
    </DSDrawer>
  );
};
